<template>
    <div>
        <!-- <v-alert dense outlined type="error" v-if="alertError">
            No fue posible la comunicación con <strong>API SERVICE</strong> ponganse en contacto con el administrador si este mensaje persiste.
        </v-alert>             -->
        
        <v-toolbar title elevation="1">
            <v-toolbar-title class="tituloMaquinaria">{{TituloTabla}}</v-toolbar-title>
            <v-divider vertical class="ml-3"></v-divider>    

            <v-spacer></v-spacer>      
            <v-text-field outlined class=" pr-4"
                label="Buscar Registro"
                v-model="buscarRegistro"
                append-icon="mdi-magnify"
                single-line
                hide-details
            ></v-text-field>
            <BotonActualizarTabla @Actualizartabla="ObtenerInventarioHerramientaPorProyecto" />
        </v-toolbar>        
        <v-data-table
            :headers="EncabezadoTablaInventarioSucursal"
            :items="ArrayInventarioHerramienta"
            class="elevation-1"
            :search="buscarRegistro"
            :footer-props="{itemsPerPageText: 'Filas por página'}"                 
            :loading="loading"
            loading-text="Cargando Datos..."                                
        >
            <template v-slot:no-data v-if="ArrayInventarioHerramienta.length === 0">
                <v-alert dense outlined class="text-xs-center textoalerta" type="warning" prominent border="left"
                >
                    No existen herramientas registradas.
                </v-alert>
            </template>                                                                         
        </v-data-table>
    </div>
</template>

<script>
import { showMessageError, showMessageSuccess } from '../../../../services/sweetAlert'
import BotonActualizarTabla from '../../../BotonActualizarTabla'

export default {
    props: {
        tab: String,
        TituloTabla: String,
        ArrayInventarioHerramienta: Array,
        loading: Boolean,
    },

    components: {
        BotonActualizarTabla,
    },    

    data() {
        return {
            buscarRegistro:'',
            EncabezadoTablaInventarioSucursal:[
                {text: 'Nombre', value: 'herramienta.catalogoHerramienta.nombre', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Marca', value: 'herramienta.catalogoHerramienta.marcaHerramienta.nombre', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Cantidad', value: 'cantidad', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Sucursal origen', value: 'herramienta.bodega.sucursal.nombre', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Bodega origen', value: 'herramienta.bodega.nombre', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Fecha Ultima Transferencia', value: 'fecha_Creacion', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                // {text: 'Acciones', value: 'action', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
            ],         
        }
    },

    created() {
    },
    methods: {
        ObtenerInventarioHerramientaPorProyecto(){
            this.$emit('ObtenerInventarioHerramientaPorProyecto')
        },
    },
}
</script>